"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIbanVerificationPaymentV1 = exports.postSmeLeadFormV1 = exports.postTariffV1 = exports.postDeliveryReportV1 = exports.getPartnersEmobilityHealthV1 = exports.postExternalPartnerQuotationV1 = exports.postSalesPartnerLeadV1 = exports.postReimbursementDetailsV1 = exports.getReimbursementDetailsV1 = exports.getCommodityDetailsV1 = exports.getEmobilityProductsV3 = exports.getCaseProductOptionsV1 = exports.getEmobilityProductsV1 = exports.getProviderContractsV1 = exports.deleteBlockChargeCardV1 = exports.getCustomerChargePointSessionsV1 = exports.getCustomerChargeCardSessionsV1 = exports.getChargePointsHttpHandlerV2 = exports.getEmobilityOnboardingCases = exports.getCustomerChargeCardsV1 = exports.getEmobilityProductsV2 = exports.getProductDetailsV1 = exports.postActionV2 = exports.postActionV1 = exports.putDeleteV1 = exports.getFilesV1 = exports.putActivateV1 = exports.postWorkorderV2 = exports.getInstallationOrderPayloadHandlerV1 = exports.postWorkorderV1 = exports.putQuotationV1 = exports.putInternalV1 = exports.getInternalV2 = exports.postEmailV2 = exports.postEmailV1 = exports.putCaseV1 = exports.getCaseV2 = exports.postReimbursementV1 = exports.postLeadV1 = exports.getEmobilityHealthV1 = exports.postProspectInternalV1 = exports.getSalesPartnerProspectV1 = exports.postSalesPartnerProspectV1 = void 0;
/**
 * Post prospect information to eMobility, returns a verification code that can be included in the email sent to customers.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PostExternalLeadResponse OK
 * @throws ApiError
 */
const postSalesPartnerProspectV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/partners/prospect/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postSalesPartnerProspectV1 = postSalesPartnerProspectV1;
/**
 * Get prospect information based on verification code
 * @param data The data for the request.
 * @param data.verificationCode
 * @returns GetExternalLeadResponse OK
 * @throws ApiError
 */
const getSalesPartnerProspectV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/partners/prospect/v1',
        query: {
            verificationCode: data.verificationCode
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getSalesPartnerProspectV1 = getSalesPartnerProspectV1;
/**
 * Post prospect information to eMobility from Cockpit.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PostProspectInternalResponse OK
 * @throws ApiError
 */
const postProspectInternalV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/partners/prospect/internal/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postProspectInternalV1 = postProspectInternalV1;
/**
 * Check service availability
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const getEmobilityHealthV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/health',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getEmobilityHealthV1 = getEmobilityHealthV1;
/**
 * submit lead form to request charging station
 * @param data The data for the request.
 * @param data.requestBody
 * @returns LeadFormDataResponse OK
 * @throws ApiError
 */
const postLeadV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/lead/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'existing_case',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postLeadV1 = postLeadV1;
/**
 * Submit reimbursement form
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @param data.requestBody
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const postReimbursementV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/reimbursement/{caseId}/v1',
        path: {
            caseId: data.caseId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postReimbursementV1 = postReimbursementV1;
/**
 * Get eMobility BPM case data for customer
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @returns CaseExistsResponse OK
 * @throws ApiError
 */
const getCaseV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/case/{caseId}/v2',
        path: {
            caseId: data.caseId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getCaseV2 = getCaseV2;
/**
 * confirm submit of images for eMobility enrichment form, update BPM case
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @param data.requestBody
 * @returns EnrichmentFormSubmission OK
 * @throws ApiError
 */
const putCaseV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/emobility/case/{caseId}/v1',
        path: {
            caseId: data.caseId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putCaseV1 = putCaseV1;
/**
 * sends an email and returns the basic info into HTML template, encoded as base64
 * Also used by SAP with basic auth with the following url: `/sap-email/{type}/v1`
 * @param data The data for the request.
 * @param data.type which email to render
 * @param data.requestBody
 * @returns Base64Response OK
 * @throws ApiError
 */
const postEmailV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/email/{type}/v1',
        path: {
            type: data.type
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postEmailV1 = postEmailV1;
/**
 * sends an email and returns the basic info into HTML template, encoded as base64
 * Also used by SAP with basic auth with the following url: `/sap-email/{type}/v1`
 * @param data The data for the request.
 * @param data.type which email to render
 * @param data.requestBody
 * @returns Base64Response OK
 * @throws ApiError
 */
const postEmailV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/bpm/email/{type}/v2',
        path: {
            type: data.type
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postEmailV2 = postEmailV2;
/**
 * Get eMobility BPM case data for agents
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @returns CaseExistsResponse OK
 * @throws ApiError
 */
const getInternalV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/case/{caseId}/internal/v2',
        path: {
            caseId: data.caseId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getInternalV2 = getInternalV2;
/**
 * update the current case for internal agents
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @param data.requestBody
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const putInternalV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/emobility/case/{caseId}/internal/v1',
        path: {
            caseId: data.caseId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putInternalV1 = putInternalV1;
/**
 * approve a quotation
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @param data.requestBody
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const putQuotationV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/emobility/case/{caseId}/quotation/v1',
        path: {
            caseId: data.caseId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putQuotationV1 = putQuotationV1;
/**
 * after quotation approval, start installation request
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const postWorkorderV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/case/{caseId}/work-order/v1',
        path: {
            caseId: data.caseId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postWorkorderV1 = postWorkorderV1;
/**
 * get the payload that was sent to Charge Cars
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @returns InstallationOrderPayloadResponse OK
 * @throws ApiError
 */
const getInstallationOrderPayloadHandlerV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/case/{caseId}/work-order/v1',
        path: {
            caseId: data.caseId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getInstallationOrderPayloadHandlerV1 = getInstallationOrderPayloadHandlerV1;
/**
 * after quotation approval, start installation request for ChargeCars
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @param data.accountId
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const postWorkorderV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/case/{caseId}/work-order/v2',
        path: {
            caseId: data.caseId
        },
        query: {
            accountId: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postWorkorderV2 = postWorkorderV2;
/**
 * callback to register Charging Station product with, after installation
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @param data.requestBody
 * @param data.agreementDate date when the charging station was installed (yyyy-mm-dd, needs zero-padding and needs to be after 26 October 2022)
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const putActivateV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/emobility/case/{caseId}/charging-station/activate/v1',
        path: {
            caseId: data.caseId
        },
        query: {
            agreement_date: data.agreementDate
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putActivateV1 = putActivateV1;
/**
 * review an uploaded file
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @param data.requestBody
 * @returns DownloadUrlResponse OK
 * @throws ApiError
 */
const getFilesV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/case/{caseId}/files/v1',
        path: {
            caseId: data.caseId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getFilesV1 = getFilesV1;
/**
 * remove an uploaded file after rejection by agent
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @param data.requestBody
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const putDeleteV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/emobility/case/{caseId}/files/delete/v1',
        path: {
            caseId: data.caseId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putDeleteV1 = putDeleteV1;
/**
 * notification to activate other Lambdas via queue
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @param data.requestBody
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const postActionV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/case/{caseId}/action/v1',
        path: {
            caseId: data.caseId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postActionV1 = postActionV1;
/**
 * notification to activate other Lambdas via queue
 * @param data The data for the request.
 * @param data.caseId BPM id of the case
 * @param data.requestBody
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const postActionV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/bpm/case/{caseId}/action/v2',
        path: {
            caseId: data.caseId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postActionV2 = postActionV2;
/**
 * get list of eMobility products
 * @param data The data for the request.
 * @param data.productId SAP id of the product
 * @returns ProductDetailsWrapper OK
 * @throws ApiError
 */
const getProductDetailsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/products/v1',
        query: {
            productId: data.productId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProductDetailsV1 = getProductDetailsV1;
/**
 * Get list of eMobility products
 * @param data The data for the request.
 * @param data.productGroup
 * @param data.verificationCode
 * @returns GetEmobilityProductsResponse OK
 * @throws ApiError
 */
const getEmobilityProductsV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/products/{productGroup}/v2',
        path: {
            productGroup: data.productGroup
        },
        query: {
            verificationCode: data.verificationCode
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getEmobilityProductsV2 = getEmobilityProductsV2;
/**
 * Get list of customer charge cards
 * @returns ChargeCardsResponse OK
 * @throws ApiError
 */
const getCustomerChargeCardsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/charge-cards/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getCustomerChargeCardsV1 = getCustomerChargeCardsV1;
/**
 * Get list of running cases
 * @returns EmobilityOnBoardingCasesResponse OK
 * @throws ApiError
 */
const getEmobilityOnboardingCases = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/onboarding-cases/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getEmobilityOnboardingCases = getEmobilityOnboardingCases;
/**
 * Get list of charge points
 * @returns ChargePointsResponse OK
 * @throws ApiError
 */
const getChargePointsHttpHandlerV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/charge-points/v2',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getChargePointsHttpHandlerV2 = getChargePointsHttpHandlerV2;
/**
 * Get list of charge card sessions
 * @param data The data for the request.
 * @param data.cardId ID of used charge card
 * @param data.from From date
 * @param data.to To date
 * @returns ChargeSessionsResponse OK
 * @throws ApiError
 */
const getCustomerChargeCardSessionsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/charge-cards/{cardId}/sessions/v1',
        path: {
            cardId: data.cardId
        },
        query: {
            from: data.from,
            to: data.to
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getCustomerChargeCardSessionsV1 = getCustomerChargeCardSessionsV1;
/**
 * Get list of charge point sessions
 * @param data The data for the request.
 * @param data.chargePointId Charge point identifier
 * @param data.from From date
 * @param data.to To date
 * @returns ChargeSessionsResponse OK
 * @throws ApiError
 */
const getCustomerChargePointSessionsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/charge-points/{chargePointId}/sessions/v1',
        path: {
            chargePointId: data.chargePointId
        },
        query: {
            from: data.from,
            to: data.to
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getCustomerChargePointSessionsV1 = getCustomerChargePointSessionsV1;
/**
 * Used to block a charge card based on customer and card number
 * @param data The data for the request.
 * @param data.cardId ID of used charge card
 * @param data.accountId
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const deleteBlockChargeCardV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/charge-cards/{cardId}/block/v1',
        path: {
            cardId: data.cardId
        },
        query: {
            accountId: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.deleteBlockChargeCardV1 = deleteBlockChargeCardV1;
/**
 * Get list of provider contracts
 * @returns ProviderContractsResponse OK
 * @throws ApiError
 */
const getProviderContractsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/provider-contracts/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProviderContractsV1 = getProviderContractsV1;
/**
 * Get list of emobility products for given account id
 * @returns EmobilityProductsResponse OK
 * @throws ApiError
 */
const getEmobilityProductsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/products/v2',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getEmobilityProductsV1 = getEmobilityProductsV1;
/**
 * Get list of available product options for the given case
 * @param data The data for the request.
 * @param data.productGroup
 * @param data.caseId
 * @param data.accountId
 * @returns GetEmobilityProductsResponse OK
 * @throws ApiError
 */
const getCaseProductOptionsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/products/{productGroup}/options/v1',
        path: {
            productGroup: data.productGroup
        },
        query: {
            caseId: data.caseId,
            accountId: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getCaseProductOptionsV1 = getCaseProductOptionsV1;
/**
 * Get list of emobility products for given account id
 * @param data The data for the request.
 * @param data.accountId
 * @returns GetCustomerProductsResponse OK
 * @throws ApiError
 */
const getEmobilityProductsV3 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/products/v3',
        query: {
            accountId: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getEmobilityProductsV3 = getEmobilityProductsV3;
/**
 * Get commodity details
 * @returns CommodityDetailsResponse OK
 * @throws ApiError
 */
const getCommodityDetailsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/commodity-details/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getCommodityDetailsV1 = getCommodityDetailsV1;
/**
 * Get reimbursement details
 * @returns ReimbursementDetailsResponse OK
 * @throws ApiError
 */
const getReimbursementDetailsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/reimbursement-details/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getReimbursementDetailsV1 = getReimbursementDetailsV1;
/**
 * Update reimbursement details
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const postReimbursementDetailsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/reimbursement-details/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postReimbursementDetailsV1 = postReimbursementDetailsV1;
/**
 * Charge station lead endpoint for external partners
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SalesPartnerLeadResponse OK
 * @throws ApiError
 */
const postSalesPartnerLeadV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/partners/lead/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postSalesPartnerLeadV1 = postSalesPartnerLeadV1;
/**
 * approval or rejection of lease quotation by lease company
 * @param data The data for the request.
 * @param data.verificationCode
 * @param data.action
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const postExternalPartnerQuotationV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/partners/quotation/v1',
        query: {
            verificationCode: data.verificationCode,
            action: data.action
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postExternalPartnerQuotationV1 = postExternalPartnerQuotationV1;
/**
 * Check service availability
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const getPartnersEmobilityHealthV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/emobility/partners/health',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getPartnersEmobilityHealthV1 = getPartnersEmobilityHealthV1;
/**
 * Delivery report endpoint for Drake & Farrell
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postDeliveryReportV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/partners/delivery-report/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postDeliveryReportV1 = postDeliveryReportV1;
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const postTariffV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/tariff/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postTariffV1 = postTariffV1;
/**
 * Submit SME lead form
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SuccessResponse OK
 * @throws ApiError
 */
const postSmeLeadFormV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/sme/lead/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postSmeLeadFormV1 = postSmeLeadFormV1;
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CreateIbanVerificationPaymentResponse OK
 * @throws ApiError
 */
const createIbanVerificationPaymentV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/emobility/payment-verification/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.createIbanVerificationPaymentV1 = createIbanVerificationPaymentV1;
